import Router from "preact-router";
import { route } from "preact-router";
import SearchBox from "./SearchBox";
import Detail from "../route/Detail";
import Search from "../route/Search";
import { useState, useEffect } from "preact/hooks";
import Feedback from "../route/Feedback";
import algolia from "../algolia";

function Main(props) {
  const [isActive, setIsActive] = useState(false);
  const [focus, setFocus] = useState(false);
  const [originalPath, setOriginalPath] = useState("/");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    algolia(props.searchIndex);
    setLoading(false);
  }, [props.searchIndex]);

  useEffect(() => {
    if (isActive) {
      document.body.style.visibility = "visible";
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  }, [isActive]);

  function onClose() {
    const path = originalPath.split("/");
    if (
      path[1] === "search" ||
      path[1] === "ballistic" ||
      path[1] === "feedback"
    ) {
      window.location = "/";
    } else {
      setIsActive(false);
      route(originalPath);
    }
  }

  useEffect(() => {
    if (props.searchIds) {
      const searchIds = props.searchIds.split(",");
      searchIds.map((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.addEventListener("focus", () => {
            setIsActive(true);
          });
        }
      });
    }
  }, [props.searchIds]);

  useEffect(() => {
    if (isActive) {
      document.getElementById("ballistic-search-input").focus();
    }
  }, [isActive]);

  if (loading) {
    return <div />;
  }

  return (
    <div id='BallisticJS'>
      {isActive && (
        <div class='fixed inset-0' style={{ zIndex: 9999 }}>
          <div class='flex items-start justify-center min-h-screen p-4 text-center sm:block sm:p-0'>
            {isActive && (
              <a
                onClick={() => setIsActive(false)}
                class='fixed inset-0 transition-opacity z-10'
              >
                <div class='absolute inset-0 bg-gray-500 opacity-75'></div>
              </a>
            )}
            {/* <!-- This element is to trick the browser into centering the modal contents. --> */}
            <span class='hidden sm:inline-block sm:align-middle sm:h-screen'></span>
            &#8203;
            {isActive && (
              <div
                class='relative z-20 flex-col inline-block align-top bg-white w-full rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle max-w-sm sm:max-w-l md:max-w-xl'
                role='dialog'
                aria-modal='true'
                aria-labelledby='modal-headline'
              >
                <header class='p-4'>
                  <SearchBox
                    focus={focus}
                    isActive={isActive}
                    onFocus={() => {
                      setFocus(true);
                      setIsActive(true);
                      // route("/search");
                    }}
                    onBlur={() => setFocus(false)}
                    onClose={onClose}
                    originalPath={originalPath}
                  />
                </header>

                <div className='overflow-scroll' style={{ maxHeight: 500 }}>
                  <Search
                    hidePrice={props.dataHidePrice}
                    quickSearches={props.quickSearches}
                  />
                </div>
                <footer>
                  <span class='flex w-full rounded-md shadow-sm'>
                    <a
                      onClick={() => setIsActive(false)}
                      class='cursor-pointer inline-flex justify-center w-full uppercase px-4 py-3 bg-gray-600 text-lg leading-6 font-medium text-white shadow-sm hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray transition ease-in-out duration-150 sm:text-sm sm:leading-5'
                    >
                      <svg
                        class='w-5 h-5 mr-2'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          stroke-width='2'
                          d='M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z'
                        ></path>
                      </svg>
                      Go back
                    </a>
                  </span>
                </footer>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Main;



// WEBPACK FOOTER //
// ./components/Main.js